import { render, staticRenderFns } from "./CustomRewardAmount.vue?vue&type=template&id=2e6c9070&scoped=true"
import script from "./CustomRewardAmount.vue?vue&type=script&lang=js"
export * from "./CustomRewardAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6c9070",
  null
  
)

export default component.exports